module.exports = __webpack_public_path__ + "static/media/tq1.7284dc56.jpg";